import { FeatureFlags } from '../config/features';
import { useFeatureStore } from '../stores/featureStore';

export const useIsFutureEnabled = (featureName: keyof FeatureFlags) => {
  const isEnabled = useFeatureStore(state => state[featureName]);
  return isEnabled;
};
